import request from '../utils/request';
import qs from "qs";
//话批服务器删除
export const serverDelete = param => {
	return request.post('/api/wholesale/serverDelete', qs.stringify(param))
};
//话批服务器编辑
export const serverUpdate = param => {
	return request.post('/api/wholesale/serverUpdate', qs.stringify(param))
};
//话批服务器添加
export const serverAdd = param => {
	return request.post('/api/wholesale/serverAdd', qs.stringify(param))
};
//话批服务器列表
export const serverList = param => {
	return request.post('/api/wholesale/serverList', qs.stringify(param))
};
//话批  消费明细导出
export const exportUseRecord = param => {
	return request.post('/api/wholesale/exportUseRecord', qs.stringify(param), {
		responseType: 'blob'
	})
};

//话批 数据看板
export const packageRaise = param => {
	return request.post('/api/wholesale/packageRaise', qs.stringify(param))
};
//话批  消费明细
export const accountJobUseRecord = param => {
	return request.post('/api/wholesale/accountUseRecord', qs.stringify(param))
};
//话批  特服号列表
export const accountJobSetMeal = param => {
	return request.post('/api/wholesale/accountSetMeal', qs.stringify(param))
};
//话批  特服号划拨
export const accountJobAssignable = param => {
	return request.post('/api/wholesale/accountAssignable', qs.stringify(param))
};
//话批  特服号分配
export const transferJobSipSetMeal = param => {
	return request.post('/api/wholesale/transferSipSetMeal', qs.stringify(param))
};
//话批  人脸信息上传
export const uploadFace = param => {
	// return request.post('/api/wholesale/uploadFace', param, {
	// 	headers: {
	// 		'Content-Type': 'multipart/form-data'
	// 	}
	// })
	return request.post('/api/wholesale/uploadFace', qs.stringify(param))
};
//话批  清除人脸信息
export const clearFaceInfo = param => {
	return request.post('/api/wholesale/clearFaceInfo', qs.stringify(param))
};
//话批  修改人脸信息
export const ModifyFaceState = param => {
	return request.post('/api/wholesale/ModifyFaceState', qs.stringify(param))
};
//话批  号码列表套餐信息
export const queryJobPackageList = param => {
	return request.post('/api/wholesale/queryPackageList', qs.stringify(param))
};
//话批  人脸认证记录
export const FaceRecord = param => {
	return request.post('/api/wholesale/FaceRecord', qs.stringify(param))
};
//话批账号  设置外呼号码
export const settingsSipAccount = param => {
	return request.post('/api/wholesale/settingsSipAccount', qs.stringify(param))
};
//话批账号价格列表
export const sipAccountPriceQuery = param => {
	return request.post('/api/wholesale/sipAccountPriceQuery', qs.stringify(param))
};
//话批账号价格设定
export const setSipAccountPrice = param => {
	return request.post('/api/wholesale/sipAccountPrice', qs.stringify(param))
};
//话批账号价格修改
export const sipAccountPriceUpdate = param => {
	return request.post('/api/wholesale/sipAccountPriceUpdate', qs.stringify(param))
};
//话批账号  列表
export const sipAccountList = param => {
	return request.post('/api/wholesale/sipAccountList', qs.stringify(param))
};
//话批账号  购买
export const sipAccountOccupy = param => {
	return request.post('/api/wholesale/sipAccountOccupy', qs.stringify(param))
};
//话批账号  生成二维码
export const sipAccountOccupyOrder = param => {
	return request.post('/api/wholesale/sipAccountOccupyOrder', qs.stringify(param))
};
//话批账号  查询订单是否支付
export const sipAccountOrderQuery = param => {
	return request.get('/api/wholesale/sipAccountOrderQuery?out_trade_no=' + param.out_trade_no)
};
//话批账号  可绑定查询
export const bindQuery = param => {
	return request.post('/api/wholesale/bindQuery', qs.stringify(param))
};
//话批账号  绑定
export const bindSetMealAccount = param => {
	return request.post('/api/wholesale/bindSetMealAccount', qs.stringify(param))
};
//话批账号  录入实名信息
export const sipAccountEnter = param => {
	return request.post('/api/wholesale/sipAccountEnter', qs.stringify(param))
};
//话批  查询代理下企业套餐模板分配情况
export const agentCompanyJobPackageList = param => {
	return request.post('/api/wholesale/agentCompanyPackageList', qs.stringify(param))
};
//话批  查询代理模板
export const agentJobTemplate = param => {
	return request.post('/api/wholesale/agentTemplate', qs.stringify(param))
};

//话批  代理下企业套餐模板分配
export const companyJobPackageAllocation = param => {
	return request.post('/api/wholesale/companyPackageAllocation', qs.stringify(param))
};

//话批  添加套餐
export const packageJobTemplate = param => {
	return request.post('/api/wholesale/packageTemplate', qs.stringify(param))
};
//话批  模版列表
export const packageJobTemplateList = param => {
	return request.post('/api/wholesale/packageTemplateList', qs.stringify(param))
};

//话批  代理获取模板
export const agentJobPackageList = param => {
	return request.post('/api/wholesale/agentPackageList', qs.stringify(param))
};
//话批  导入套餐
export const agentJobAddPackage = param => {
	return request.post('/api/wholesale/agentAddPackage', qs.stringify(param))
};
//话批账号  客户质量
export const qualityControl = param => {
	return request.post('/api/wholesale/qualityControl', qs.stringify(param))
};

//话批账号  通话数据
export const callData = param => {
	return request.post('/api/wholesale/callData', qs.stringify(param))
};

//话批账号  套餐订购
export const packageOrder = param => {
	return request.post('/api/wholesale/packageOrder', qs.stringify(param))
};

//话批账号  套餐消耗
export const packageUsageByPageNo = param => {
	return request.post('/api/wholesale/packageUsageByPageNo', qs.stringify(param))
};
//话批账号  套餐面板
export const packageUsage = param => {
	return request.post('/api/wholesale/packageUsage', qs.stringify(param))
};